import React from 'react';
import { Table } from 'react-bootstrap';
import { FaEye } from 'react-icons/fa';
import moment from 'moment';
import { EstadoBadge } from './EstadoBadge';

moment.locale('es');

/**
 * Componente de tabla para mostrar lista de ingresos
 * @param {Array} ingresos - Array de ingresos a mostrar
 * @param {Function} onIngresoClick - Función al hacer click en un ingreso
 * @param {Function} onObservacionClick - Función al hacer click en observaciones
 */
export const IngresoTable = ({ ingresos, onIngresoClick, onObservacionClick }) => {
  if (!Array.isArray(ingresos) || ingresos.length === 0) {
    return null;
  }

  return (
    <div className="table-responsive">
      <Table striped hover className="w-100 align-middle">
        <thead className="bg-primary text-white">
          <tr>
            <th>N° Ingreso</th>
            <th>Cliente</th>
            <th>Autor</th>
            <th>F. Ingreso</th>
            <th>F. Salida</th>
            <th className="text-center">
              <FaEye />
            </th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          {ingresos.map((ingreso) => {
            const numeroIngreso = `I-${ingreso?.numeroOrden}-${ingreso?.consecutivo}`;
            // Usar nameClient directamente del objeto ingreso
            const clienteNombre = ingreso?.nameClient || ingreso?.equipos?.[0]?.equipo?.equipo?.cliente?.nombre || 'N/A';
            // El autor puede ser un ObjectId o un objeto poblado
            const autorNombre = ingreso?.autor?.nombre 
              ? `${ingreso.autor.nombre} ${ingreso.autor.apellido || ''}`.trim()
              : 'N/A';
            const fechaIngreso = moment(ingreso?.fechaIngreso).format("DD/MM/YYYY");
            const fechaSalida = ingreso.estado === 'Abierta'
              ? moment(ingreso?.fechaSalidaEstimada).format("DD/MM/YYYY")
              : moment(ingreso?.fechaSalida).format("DD/MM/YYYY");

            return (
              <tr 
                key={ingreso._id}
                style={{ cursor: 'pointer' }}
                onClick={() => onIngresoClick(ingreso)}
              >
                <td>
                  <span className="text-primary fw-bold">
                    {numeroIngreso}
                  </span>
                </td>
                <td>{clienteNombre}</td>
                <td>{autorNombre}</td>
                <td>{fechaIngreso}</td>
                <td>
                  {fechaSalida}
                  {ingreso.estado === 'Abierta' && (
                    <small className="text-muted d-block">(Estimada)</small>
                  )}
                </td>
                <td className="text-center">
                  {ingreso.observacion && (
                    <FaEye
                      className="text-info cursor-pointer"
                      size={18}
                      onClick={(e) => {
                        e.stopPropagation();
                        onObservacionClick(ingreso);
                      }}
                      style={{ cursor: 'pointer' }}
                      title="Ver observaciones"
                    />
                  )}
                </td>
                <td onClick={(e) => e.stopPropagation()}>
                  <EstadoBadge ingreso={ingreso} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};
